import { render } from "./HelpActionButton.vue?vue&type=template&id=2ac1705a&scoped=true&ts=true"
import script from "./HelpActionButton.vue?vue&type=script&lang=ts"
export * from "./HelpActionButton.vue?vue&type=script&lang=ts"

import "./HelpActionButton.vue?vue&type=style&index=0&id=2ac1705a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac1705a"]])

export default __exports__